/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  model() {
    let store = this.store;
    return hash({
      assessments: store.findAll('assessments/assessment'),
      categories: store.findAll('assessments/category'),
      gradeschedules: store.findAll('assessments/grade-schedule'),
      usageSets: store.findAll('schools/usage-set'),
      schools: this.store.findAll('school'),
      schoolGroups: this.store.findAll('schools/group'),
    });
  }
}
